// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-product-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding-top: 10px;
  padding-bottom: 20px;
}
.container-product-list h3 {
  font-family: var(--font);
  font-size: 16px;
  font-weight: 600;
  color: var(--dark-blue);
  margin: 0;
}

.container-product-list h3 strong {
  font-family: var(--font);
  font-size: 16px;
  color: var(--blue);
}

.container-product-list .ticket-list {
  box-sizing: border-box;
  gap: 10px;
  width: 90%;
  padding: 0;
  height: calc(100vh - 200px);
  margin: 0;
  list-style: none;
  overflow: auto;
  overflow-x: hidden;
  padding-bottom: 10px;

}

.ticket-list li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 10px 10px;
  background-color: #f3f3f3;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.4);
  box-sizing: border-box;
  border: none;
  border-radius: 6px;
}

.ticket-list li > div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  width: 100%;
}

.ticket-list li strong {
  font-family: var(--font);
  font-size: 14px;
  font-weight: 700;
  color: var(--dark-blue);
  line-height: 5px;
  text-decoration: underline;
}

.ticket-list li input[type='checkbox'] {
  width: 25px;
  height: 25px;
  transition: all 0.3s ease-in-out;

}

.ticket-list li .clients-assigned {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  box-sizing: border-box;
  gap: 5px;
  width: 100%;
  padding: 0 15px;
}

.ticket-list li .clients-assigned span {
  font-family: var(--font);
  font-weight: 700;
  color: var(--dark-blue);
}

.clients-5 {
  font-size: 12px;
  letter-spacing: -0.5px;
  line-height: 15px;
}

.clients-2 {
  font-size: 14px;
  letter-spacing: -0.5px;
  line-height: 5px;
}

.ticket-list li > div .product-info {
  font-family: var(--font);
  font-size: 14px;
  font-weight: 600;
}


.container-product-list button {
  width: 160px;
  border: none;
  border-radius: 5px;
  background-color: var(--dark-blue);
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  padding: 6px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductList/ProductList.css"],"names":[],"mappings":"AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,UAAU;EACV,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;;AAEtB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,8CAA8C;EAC9C,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;;AAElC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,8CAA8C;AAChD","sourcesContent":["@import url('/src/App.css');\n.container-product-list {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  padding-top: 10px;\n  padding-bottom: 20px;\n}\n.container-product-list h3 {\n  font-family: var(--font);\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--dark-blue);\n  margin: 0;\n}\n\n.container-product-list h3 strong {\n  font-family: var(--font);\n  font-size: 16px;\n  color: var(--blue);\n}\n\n.container-product-list .ticket-list {\n  box-sizing: border-box;\n  gap: 10px;\n  width: 90%;\n  padding: 0;\n  height: calc(100vh - 200px);\n  margin: 0;\n  list-style: none;\n  overflow: auto;\n  overflow-x: hidden;\n  padding-bottom: 10px;\n\n}\n\n.ticket-list li {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 10px;\n  background-color: #f3f3f3;\n  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.4);\n  box-sizing: border-box;\n  border: none;\n  border-radius: 6px;\n}\n\n.ticket-list li > div {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n}\n\n.ticket-list li strong {\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--dark-blue);\n  line-height: 5px;\n  text-decoration: underline;\n}\n\n.ticket-list li input[type='checkbox'] {\n  width: 25px;\n  height: 25px;\n  transition: all 0.3s ease-in-out;\n\n}\n\n.ticket-list li .clients-assigned {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  gap: 5px;\n  width: 100%;\n  padding: 0 15px;\n}\n\n.ticket-list li .clients-assigned span {\n  font-family: var(--font);\n  font-weight: 700;\n  color: var(--dark-blue);\n}\n\n.clients-5 {\n  font-size: 12px;\n  letter-spacing: -0.5px;\n  line-height: 15px;\n}\n\n.clients-2 {\n  font-size: 14px;\n  letter-spacing: -0.5px;\n  line-height: 5px;\n}\n\n.ticket-list li > div .product-info {\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 600;\n}\n\n\n.container-product-list button {\n  width: 160px;\n  border: none;\n  border-radius: 5px;\n  background-color: var(--dark-blue);\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 6px;\n  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
